const collator = new Intl.Collator("es", { sensitivity: "base", numeric: true });

export function sortByName(items) {
  return items.slice().sort((a, b) => collator.compare(a.name || "", b.name || ""));
}

export function matchesSearch(item, query) {
  const normalize = text => String(text || "").normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("es");
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  const text = normalize((item.name || "") + " " + (item.description || ""));
  return words.every(word => text.includes(word));
}

// Ordenar la vista nunca modifica las claves ni las posiciones almacenadas.
export function filterDishGroups(groups, query) {
  return sortByName(groups).map(group => ({
    ...group,
    plu: sortByName(group.plu || []).filter(dish =>
      matchesSearch(group, query) || matchesSearch(dish, query))
  })).filter(group => matchesSearch(group, query) || group.plu.length > 0);
}

// Reordenar familias conserva los platos de las existentes; las nuevas empiezan vacías.
export function reconcileMenuGroups(groups, selectedKeys) {
  return [...new Set(selectedKeys)].map((keyOriginal, key) => {
    const existing = groups.find(group => group.keyOriginal === keyOriginal);
    return { ...(existing || {}), key, keyOriginal, plu: existing ? existing.plu.slice() : [] };
  });
}
